class FloorPlanTemplateDataModel {
  constructor(props) {
    this.id = props.id;
    this.name = props.name;
    this.background = props.background;
  }
}

export default FloorPlanTemplateDataModel;
